<template>
    <div class="faq">
        <default :items="items" :title="'FAQ'" :with-accordion="true" :is-accordion-group="true" :wrap-content="true"></default>
    </div>
</template>

<script>
import Default from '@theme-views/public/layouts/Default'
import Faq from '@views/public/pages/Faq/faq'

export default {
    mixins: [Faq],
    components: {
        Default
    }
}
</script>

<style lang="scss">
.faq {

}
</style>
